import Vue from 'vue';
import FastClick from 'fastclick';

import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';

import 'vue-ydui/dist/ydui.base.css';
import './styles/main.scss';
import App from './App';
import router from './router';


if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', () => {
    FastClick.attach(document.body);
  }, false);
}


Vue.use(YDUI);


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js